import {SortOrder} from '../../schema/constants';

export const sortByString = (
	a: string,
	b: string,
	order: SortOrder = SortOrder.ASCENDING,
) => a.localeCompare(b) * (order === SortOrder.ASCENDING ? 1 : -1);
